if (typeof window !== "undefined") {
  import("posthog-js").then((ph: any) => {
    const posthog = ph.default ?? ph;
    posthog.init("phc_mw1z417lVdK66QFnWviaPfdJUsCJAqOeKwACcXrAPrE", {
      api_host: "https://app.posthog.com",
    });
    (globalThis as Record<string, unknown>)._posthog = posthog;
  });
}

const getPosthog = () =>
  (globalThis as Record<string, unknown>)._posthog as
    | { capture: (event: string, properties?: Record<string, unknown>) => void }
    | undefined;

export const conversion = async (email: string) => {
  await registerConversionWithGoogle();
  getPosthog()?.capture("Email submission", { email });
};

const registerConversionWithGoogle = () =>
  new Promise<void>((resolve) =>
    // @ts-expect-error defined in index.html
    gtag("event", "conversion", {
      send_to: "AW-1031308281/O4dSCIvhxOwYEPmH4usD",
      transaction_id: "",
      event_callback: resolve(),
    })
  ).catch(() => console.error("failed registering conversion"));
